@if(config().descriptionBlock?.isNullOrEmpty() === false) {
    <lsa-description-block [descriptionBlockConfig]="config().descriptionBlock!"></lsa-description-block>
}
@if(showSpinner()){
    <mat-spinner></mat-spinner>
}
@else {
    <lsa-video-carrousel (videoClick)="onPlaylistClick($event)" [videoTitlePrefix]="'Serie: '" [videos]="playlists()"></lsa-video-carrousel>
}
